// src/layouts/LandingPageCountdown/LandingPageCountdown.js

import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

const LandingPageLinks = ({ linksTopContent, firstLink, secondLink }) => {
  return (
    <BlockContent>
      <div className="border-outline">
        <div
          className="top-content"
          dangerouslySetInnerHTML={{ __html: linksTopContent }}
        />
        <div class="flex-row">
          <div class="link-col">
            <GatsbyImage
              image={
                firstLink.firstLinkImage.localFile.childImageSharp
                  .gatsbyImageData
              }
              alt={firstLink.firstLinkTitle}
            />
            <div class="link-col-content">
              <h3>{firstLink.firstLinkTitle}</h3>
              <p>{firstLink.firstLinkDescription}</p>
              <p>
                <a
                  href={firstLink.firstLinkLink}
                  target={firstLink.firstLinkNewTab ? "_blank" : "_self"}
                >
                  Learn More
                </a>
              </p>
            </div>
          </div>
          <div class="link-col">
            <GatsbyImage
              image={
                secondLink.secondLinkImage.localFile.childImageSharp
                  .gatsbyImageData
              }
              alt={secondLink.secondLinkTitle}
            />
            <div class="link-col-content">
              <h3>{secondLink.secondLinkTitle}</h3>
              <p>{secondLink.secondLinkDescription}</p>
              <p>
                <a
                  href={secondLink.secondLinkLink}
                  target={secondLink.secondLinkNewTab ? "_blank" : "_self"}
                >
                  Learn More
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </BlockContent>
  )
}

const BlockContent = styled.section`
  max-width: 1210px;
  width: 100%;
  margin: 50px auto;
  margin-bottom: 100px;
  padding: 0 20px;
  .border-outline {
    border: 5px solid #c44c4a;
    padding: 70px 90px;
  }
  .flex-row {
    display: flex;
    gap: 30px;
    margin-top: 30px;
    .link-col {
      background-color: #ebebeb;
      display: flex;
      .gatsby-image-wrapper {
        width: 170px;
      }
      .link-col-content {
        width: calc(100% - 170px);
        padding: 25px;
        p {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 15px;
          &:last-child {
            margin-bottom: 0;
          }
          a {
            color: #2b2520;
            font-weight: bold;
            text-decoration: none;
          }
        }
      }
    }
  }
  h1 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 60px;
    color: #2b2520;
    margin-top: 20px;
  }
  h2 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    color: #2b2520;
    margin-top: 0;
  }
  h3 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    line-height: 24px;
    color: #2b2520;
    margin-top: 0;
    margin-bottom: 10px;
  }
  h4 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    line-height: 48px;
    color: #2b2520;
    margin-top: 0;
  }
  p.large {
    font-size: 32px;
    margin-bottom: 35px;
  }
  p,
  ul,
  ol {
    font-family: "Work Sans";
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: #777c7c;
    margin-bottom: 0;
  }
  ul,
  ol {
    margin-left: 20px;
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 20px 50px;
    flex-wrap: wrap;
    .border-outline {
      padding: 40px 70px;
    }
    .flex-row {
      flex-wrap: wrap;
      gap: 0px;
      .link-col {
        width: 100%;
        flex-wrap: wrap;
        margin-bottom: 30px;
        .gatsby-image-wrapper {
          width: 100%;
          height: 200px;
        }
        .link-col-content {
          width: 100%;
        }
      }
    }
    h2 {
      font-size: 44px;
      line-height: 1.3;
      margin-bottom: 10px;
      padding-left: 0;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    margin: 20px auto;
    .border-outline {
      padding: 20px;
    }
    h2 {
      font-size: 36px;
    }
  }
`

export default LandingPageLinks
